<template>
  <div class="app-container">
    <!-- <div class="detailsTitle">
      <h4>仓位库存中远2.0</h4>
    </div> -->
    <!--查询条件-->
    <div ref="searchBox" class="formBox margbot" >
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="95px"
        size="mini">
        <div class="formItemBox">
          <el-form-item label="仓位:" style="margin-top:7px;">
            <el-select filterable v-model="searchFrom.warehouseId" @change="changeCangWei(searchFrom.warehouseId)"
              size="mini" placeholder="请选择仓位名" clearable>
              <el-option v-for="(item, index) in CWData" :key="index" :label="item.warehouseName"
                :value="item.warehouseId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区位:" style="margin-top:7px;">
            <el-select filterable v-model="searchFrom.locationId" size="mini" placeholder="请选择仓位名" :disabled="disQu1"
              clearable>
              <el-option v-for="(item, index) in QWData" :key="index" :label="item.locationName"
                :value="item.locationId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货物类型:" style="margin-top:7px;">
            <el-select v-model="searchFrom.productType" clearable @change="productTypeChange" placeholder="请选择"
              filterable>
              <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName"
                :value="item.productType">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产地:" style="margin-top:7px;">
            <el-select v-model="searchFrom.steelMillName" @change='steelMillNameChange' clearable placeholder="请选择"
              filterable>
              <el-option v-for="(item, index) in steelMillNameData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="规格:" style="margin-top:7px;">
            <el-select v-model="searchFrom.specification" clearable @change='specificationChange' placeholder="请选择"
              filterable>
              <el-option v-for="(item, index) in specificationData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材质:" style="margin-top:7px;">
            <el-select v-model="searchFrom.model" @change="modelChange" clearable placeholder="请选择" filterable>
              <el-option v-for="(item, index) in modelData" :key="index" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="件数:" style="margin-top:7px;">
            <el-select v-model="searchFrom.number" clearable placeholder="请选择">
              <el-option v-for="(item, index) in numberOptions" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否优先:"  style="margin-top:7px;">
            <el-select  v-model="searchFrom.upMark" filterable placeholder="请选择">
              <el-option  label="全部" value="" ></el-option>
                <el-option  label="是" value="2" ></el-option>
                <el-option  label="否" value="1" ></el-option>
              </el-select>
          </el-form-item>
        </div>
        <div class="searchBtnBox" style="margin-bottom: 2px;">
          <el-form-item>
            <el-button type="primary" @click="searchClick" btnCode="003P01nB001" v-if="btnFlg[0]">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="chongZhiClick" btnCode="003P01nB002" v-if="btnFlg[1]">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="turnClick" btnCode="003P01nB003" v-if="btnFlg[2]">移库</el-button>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="clearBtn" btnCode="003P01nB004" v-if="btnFlg[3]">清零</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="exportClick" btnCode="003P01nB005" v-if="btnFlg[4]">导出</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="daoru" btnCode="003P01nB006" v-if="btnFlg[5]">导入</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="modelDown" btnCode="003P01nB007"
              v-if="btnFlg[6]">下载模版</el-button>
          </el-form-item>
           <el-form-item>
            <el-button type="primary" @click="youxianFn"  v-if="btnFlg[7]">优先</el-button>
          </el-form-item>
           <el-form-item>
            <el-button type="primary" @click="QXyouxianFn"  v-if="btnFlg[8]">取消优先</el-button>
          </el-form-item>
          <el-form-item>
          <div style="display: flex;">
            <div style="display: flex;">
              <div>总吨数：</div>
              <div style="color:red;">{{ Number(totalAllWeight).toFixed(3) }}</div>&nbsp;&nbsp;吨
            </div>
            <div style="margin-left:20px;display: flex;">
              <div>总件数：</div>
              <div style="color:red;">{{ totalNumber }}</div>&nbsp;&nbsp;件
            </div>
          </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }" v-loading='tabLoading'>
      <el-table :data="tableList" ref="tableRef" border bordersize="mini" height="100%"
        style="width: 100%; margin-top: 10px" center :fit='true' @row-click="handleRowClick" :cell-style="getCellStyle"
        @current-change="handleTabCurrentChange" :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        :header-row-style="{ height: '45px' }" :row-style="{ height: '35px' }" highlight-current-row
        @selection-change="selectGoods">
        <el-table-column type="selection" width="55" align="center"></el-table-column>
        <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="warehouseName" label="仓位" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型"
          align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" align="center"></el-table-column>
         <el-table-column property="auditStatus" label="是否优先" width="80">
              <template scope="scope">
                <div>
                  <span v-if="scope.row.upMark==2" style="color: red;">是</span>
                  <span v-if="scope.row.upMark==1">否</span>
                </div>
              </template>
            </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.allWeight == undefined || scope.row.allWeight == ''"></span>
              <span v-else>{{ Number(scope.row.allWeight).toFixed(3) }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.weight == undefined || scope.row.weight == ''"></span>
              <span v-else>{{ Number(scope.row.weight).toFixed(3) }}</span>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="stockPoundWeight" label="过磅净重（吨）" align="center" >
          <template slot-scope="scope"><div>
            <span v-if="scope.row.stockPoundWeight == undefined || scope.row.stockPoundWeight == '' || scope.row.stockPoundWeight == null"></span>
            <span v-else>{{Number(scope.row.stockPoundWeight).toFixed(3)}}</span>
          </div></template>
        </el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="avgWeight" label="平均重量（吨）" align="center">
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.avgWeight == undefined || scope.row.avgWeight == ''"></span>
              <span v-else>{{ Number((scope.row.avgWeight)).toFixed(3) }}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pageNo" :page-sizes="[10, 20, 30, 40, 50]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 移库 -->
    <el-dialog title="移库" :close-on-click-modal="false" :visible.sync="yikuVisible" width="90%" center>
      <el-table :data="yikuTableList" ref="yikuTableList" border bordersize="mini"
        style="width: 100%;height:100px;margin-top:10px;" center
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }" :header-row-style="{ height: '45px' }"
        :row-style="{ height: '35px' }" highlight-current-row :header-cell-class-name="Add">
        <el-table-column prop="primaryCustomerName" label="目标仓位" align="center" width="140">
          <template slot-scope="scope">
            <el-select filterable v-model="scope.row.transferWarehouseId"
              @change="changeCangWeiYK(scope.row,scope.row.transferWarehouseId)" size="mini" placeholder="请选择仓位" clearable>
              <el-option v-for="(item, index) in CangweiOptions" :key="index" :label="item.warehouseName"
                :value="item.warehouseId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="primaryCustomerName" label="目标区位" align="center" width="140">
          <template slot-scope="scope">
            <el-select filterable v-model="scope.row.transferLocationId" size="mini" placeholder="请选择区位" clearable>
              <el-option v-for="(item, index) in QuweiOptions" :key="index" :label="item.locationName"
                :value="item.locationId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="stockAvailableNumber" label="仓位可移件数" align="center" width="120"></el-table-column>
        <el-table-column prop="transferNumber" label="移库件数" align="center" width="140">
          <template slot-scope="scope">
            <div>
              <el-input placeholder="请输入件数" @input="jianInput" v-number-input.float="0" maxlength="100"
                v-model="scope.row.transferNumber" size="mini"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="stockWeight" label="移库理重(吨)" align="center" width="120">
          <template slot-scope="scope">
            <div>
              <el-input placeholder="" :disabled="true" size="mini" v-model="scope.row.stockWeightY"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="transferPoundWeight" label="移库磅重(吨)" align="center" width="120">
          <template slot-scope="scope">
            <div>
              <el-input placeholder="请输入磅重" v-number-input.float="3" maxlength="100"
                v-model="scope.row.transferPoundWeight" size="mini"></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="number" label="件数" align="center"></el-table-column>
        <el-table-column prop="allWeight" label="总重量(吨)" align="center"></el-table-column>
        <el-table-column prop="productTypeName" label="货物类型" align="center"></el-table-column>
        <el-table-column prop="steelMillName" label="产地" align="center"></el-table-column>
        <el-table-column prop="specification" label="规格" align="center"></el-table-column>
        <el-table-column prop="model" label="材质" align="center"></el-table-column>
        <el-table-column prop="warehouseName" label="仓位" align="center"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="locationName" label="区位" align="center"></el-table-column>

      </el-table>
      <div slot="footer">
        <el-button @click="yikuQuXiao">取 消</el-button>
        <el-button type="primary" :loading="yikuLoading" @click="yikuOk">保 存</el-button>
      </div>
    </el-dialog>
    <!--点击导入按钮弹出框-->
    <div class="addMarkBox" custom-class="el-dialog--center">
      <el-dialog @close="closeDialogFile" title="导入" :visible.sync="daoruMark" :close-on-click-modal="false" width="40%"
        center>
        <div style="margin: 15px auto" class="el-dialog--center">
          <input type="file" ref="file" accept=".xls, .csv, .xlsx" @change="getFile($event)" />
        </div>
        <div style="margin: 15px auto" class="el-dialog--center">
          <el-button @click="daoruMark = false">取消</el-button>
          <el-button type="primary" @click="daoruQueding()" :disabled="isDisable1">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {
  getVirtualBalingList, // 货物类型、产地、规格、材质、长度、件数级联查询
  JfgetStockWarehouseAvailableNumber,
  JfgetStockWarehouseListZY,
  JfclearStockWarehouse,
  JftransferStockThreadZY,
  JfimportStockWarehouse,
  zidianQuwei,
  JfgetStockWarehouseWN,
  getWeighingMethodList,
  addMoveUpMark,
  deleteMoveUpMark

} from '@/api/wms-stock.js'
import { getBtn } from '@/utils/getButton'
import { emptyFn, formatterRowEmpty } from '@/utils/util'
import DonMessage from '@/utils/message'
import { exportExcel } from '@/utils/fileDown.js'
import { zidianKuwei } from '@/api/wms-access.js'

export default {
  data () {
    return {
      emptyFn: emptyFn,
      formatterRowEmpty: formatterRowEmpty,
      // 按钮
      btnFlg: [],
      btnIdArr: [
        '003P01nB001',
        '003P01nB002',
        '003P01nB003',
        '003P01nB004',
        '003P01nB005',
        '003P01nB006',
        '003P01nB007',
        '003M390100', '003M390200'
      ],
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        model: '',
        warehouseId: '',
        locationId: '',
        productType: '',
        steelMillName: '',
        specification: '',
        number: ''
      },
      pageNo: 1,
      pageSize: 20,
      customerData: [], // 货主数据
      productTypeData: [], // 货物类型
      steelMillNameData: [], // 产地
      specificationData: [], // 规格
      modelData: [], // 材质
      QuweiOptions: [],
      lengthData: [],
      numberOptions: [{
        value: '',
        label: '全部'
      }, {
        value: '0',
        label: '0'
      }, {
        value: '-1',
        label: '不为0'
      }],
      CWData: [],
      QWData: [],
      disQu1: true,
      specificationDisabled: true,
      steelMillNameDisabled: true,
      modelDisabled: true,
      lengthDisabled: true,
      goodsName: '',
      placeOfOrigin: '',
      specificationVal: '',
      modelVal: '',
      value: '',
      tableList: [],
      tabLoading: false,
      // 修改
      changeFlag: '', // 1自动  2 手动
      changeData: {}, // 修改需携带的数据
      turnGoodsTableList: [],
      changeFrom: {
        primaryCustomerTaxId: '',
        customerTaxId: '',
        newPrimaryCustomerName: '',
        newSecondaryCustomerName: ''
      },
      plantNoByShipName: [],
      stockInf: [],
      turnLoading: false,
      portOptions: [], // 港口
      baoCunData: [],
      changeNumber: '',
      changeWeight: '',
      dialogVisible: false,
      dialogImageUrl: '',
      arrImg: [],
      isDisable: false,
      seen: true,
      seen2: true,
      seen3: false,
      totalAllWeight: '0', // 总吨数
      totalNumber: '0', // 总件数
      yikuVisible: false,
      yikuLoading: false,
      yikuTableList: [],
      CangweiOptions: [],
      residue: 0,
      inWeighingMethod: 0,
      disShow: false,
      changeAllWeight: 0,
      daoruMark: false,
      isDisable1: false,
      selectListId: [],
      selectList: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/warehouseTwo')
    this.getVirtualBalingList()
    this.JfgetStockWarehouseListZYs()
    this.zidianKuweiS()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        if (_this.yikuVisible == true) {
          _this.yikuOk()
        } else {
          _this.searchClick()
        }
      }
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 170 + 'px'
  },
  methods: {
    // 优先
    youxianFn () {
      let selectData = this.$refs.tableRef.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      let arr = selectData.map(item => item.stockWarehouseId)
      this.$confirm('是否执行优先操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        addMoveUpMark({
          stockWarehouseIds: arr
        }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.JfgetStockWarehouseListZYs()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 取消 优先
    QXyouxianFn () {
      let selectData = this.$refs.tableRef.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      let arr = selectData.map(item => item.stockWarehouseId)
      this.$confirm('是否执取消行优先操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteMoveUpMark({
          stockWarehouseIds: arr
        }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.JfgetStockWarehouseListZYs()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 材质是HRB500E就标称红色
    getCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'model' && row.model == 'HRB500E') {
        return { color: 'red' }
      }
    },
    changeCangWeiYK (row, val) {
      this.$set(row, 'transferLocationId', '')

      zidianQuwei({
        warehouseId: val
      })
        .then((res) => {
          this.QuweiOptions = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    changeCangWei (val) {
      this.disQu1 = false
      this.searchFrom.locationId = ''
      zidianQuwei({
        warehouseId: val
      })
        .then((res) => {
          this.QWData = res
        })
        .catch((err) => {
          // console.log(err);
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 小星星
    Add (obj) {
      if (obj.column.property == 'primaryCustomerName' || obj.column.property == 'transferNumber') {
        return 'star'
      }
      if (this.yikuTableList.length > 0 && (this.yikuTableList[0].inWeighingMethod == 2 || this.yikuTableList[0].inWeighingMethod == 3)) {
        if (obj.column.property == 'transferPoundWeight') {
          return 'star'
        }
      }
    },
    JfgetStockWarehouseWNs () {
      JfgetStockWarehouseWN({
        pageNo: this.searchFrom.pageNo,
        pageSize: this.searchFrom.pageSize,
        model: this.searchFrom.model,
        warehouseId: this.searchFrom.warehouseId,
        locationId: this.searchFrom.locationId,
        productType: this.searchFrom.productType,
        steelMillName: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        number: this.searchFrom.number,
        upMark: this.searchFrom.upMark
      })
        .then(res => {
          console.log(res)
          this.totalAllWeight = res.totalWeight
          this.totalNumber = res.totalNumber
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    // 列表查询
    JfgetStockWarehouseListZYs () {
      JfgetStockWarehouseListZY(
        {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          model: this.searchFrom.model,
          warehouseId: this.searchFrom.warehouseId,
          locationId: this.searchFrom.locationId,
          productType: this.searchFrom.productType,
          steelMillName: this.searchFrom.steelMillName,
          specification: this.searchFrom.specification,
          number: this.searchFrom.number,
          upMark: this.searchFrom.upMark
        }
      )
        .then(res => {
          console.log(res)
          this.JfgetStockWarehouseWNs()
          this.tableList = res.list
          this.total = res.total
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    selectGoods (selection) {
      this.selectListId = []
      this.selectList = selection
      let arry = []
      selection.forEach((item) => {
        arry.push(item.stockWarehouseId) // id数组
        arry = Array.from(new Set(arry)) // 去重
      })
      console.log(arry)
      this.selectListId = arry.join(',') // 获取全部货物id
    },
    // 清零
    clearClick () { },
    // 移库
    turnClick () {
      if (this.selectList.length == 0) {
        this.$message({ message: '请先选择一条数据', type: 'error' })
        return
      } else if (this.selectList.length > 1) {
        this.$message({ message: '请选择一条数据', type: 'error' })
        return
      }
      this.yikuVisible = true
      this.zidianKuweiS()
      this.yikuTableList = []
      getWeighingMethodList(
        {
          productType: this.selectList[0].productType
        }
      )
        .then(res => {
          JfgetStockWarehouseAvailableNumber({
            stockWarehouseId: this.selectList[0].stockWarehouseId
          })
            .then(res1 => {
              console.log(res)
              let obj = {
                transferWarehouseId: '',
                transferLocationId: '',
                transferNumber: '',
                stockWeightY: '',
                transferPoundWeight: '',
                allWeightY: '',
                stockAvailableNumber: res1,
                inWeighingMethod: res[0].inWeighingMethod,
                ...this.selectList[0]
              }
              this.yikuTableList.push(obj)
            })
            .catch(err => {
              this.$message({ message: err.message, type: 'error' })
            })
        })
    },
    yikuQuXiao () {
      this.yikuVisible = false
    },
    yikuOk () {
      if (this.yikuTableList[0].transferWarehouseId == '' || this.yikuTableList[0].transferLocationId == '' || this.yikuTableList[0].transferNumber == '') {
        this.$message({ message: '请先填写信息', type: 'error' })
        return
      } else if (this.yikuTableList[0].inWeighingMethod == '2' && this.yikuTableList[0].transferPoundWeight == '') {
        this.$message({ message: '请填写移库磅重', type: 'error' })
        return
      } else if (this.yikuTableList[0].inWeighingMethod == '3' && this.yikuTableList[0].transferPoundWeight == '') {
        this.$message({ message: '请填写移库磅重', type: 'error' })
        return
      }
      if (this.yikuTableList[0].transferNumber > this.yikuTableList[0].stockAvailableNumber) {
        this.$message({ message: '移库件数不能大于库存可移件数', type: 'error' })
      }
      let obj = this.yikuTableList[0]
      this.CangweiOptions.forEach(item => {
        if (item.warehouseId == obj.transferWarehouseId) {
          obj.transferWarehouseName = item.warehouseName
        }
      })
      this.QuweiOptions.forEach(item => {
        if (item.locationId == obj.transferLocationId) {
          obj.transferLocationName = item.locationName
        }
      })
      JftransferStockThreadZY({ ...obj })
        .then(res => {
          this.$message({ message: '移库成功', type: 'success' })
          this.yikuVisible = false
          this.JfgetStockWarehouseListZYs()
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      // }).catch(err => {
      //   this.$message({ message: err.message, type: 'error' })
      // })
    },
    jianInput () {
      this.yikuTableList[0].stockWeightY = Number(this.yikuTableList[0].transferNumber / 1 * this.yikuTableList[0].singletonWeight / 1).toFixed(3)
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          console.log(res)
          this.steelMillNameData = []
          this.specificationData = []
          this.modelData = []
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
          // this.productTypeData = Array.from(new Set(res.map(item => item.productTypeName)))
          this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
          this.specificationData = Array.from(new Set(res.map(item => item.specification)))
          this.modelData = Array.from(new Set(res.map(item => item.model)))
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 货物类型下拉框改变事件
    productTypeChange (val) {
      // this.goodsName = val
      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 产地下拉框改变事件
    steelMillNameChange (val) {
      // this.placeOfOrigin = val
      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []

        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 规格下拉框改变事件
    specificationChange (val) {
      // this.specificationVal = val
      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 材质下拉框改变事件
    modelChange (val) {
      // this.modelVal = val
      getVirtualBalingList({
        productType: this.searchFrom.productType,
        placeOfOrigin: this.searchFrom.steelMillName,
        specification: this.searchFrom.specification,
        model: this.searchFrom.model
      }).then(res => {
        this.lengthData = []
        this.steelMillNameData = []
        this.specificationData = []
        this.modelData = []
        this.productTypeData = []
        var obj = {}
        for (var i = 0; i < res.length; i++) {
          if (!obj[res[i].productTypeName]) {
            this.productTypeData.push(res[i])
            obj[res[i].productTypeName] = true
          }
        }
        this.steelMillNameData = Array.from(new Set(res.map(item => item.placeOfOrigin)))
        this.specificationData = Array.from(new Set(res.map(item => item.specification)))
        this.modelData = Array.from(new Set(res.map(item => item.model)))
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击查询按钮
    searchClick () {
      this.JfgetStockWarehouseListZYs()
    },
    // 点击重置
    chongZhiClick () {
      this.searchFrom.model = ''
      this.searchFrom.warehouseId = ''
      this.searchFrom.locationId = ''
      this.searchFrom.productType = ''
      this.searchFrom.steelMillName = ''
      this.searchFrom.specification = ''
      this.searchFrom.number = ''
      this.searchFrom.upMark = ''
      this.getVirtualBalingList()
      this.JfgetStockWarehouseListZYs()
    },
    // 每页条数
    handleSizeChange (val) {
      this.pageSize = val
      this.JfgetStockWarehouseListZYs()
    },
    // 当前页
    handleCurrentChange (val) {
      this.pageNo = val
      this.JfgetStockWarehouseListZYs()
    },
    // 点击选中
    handleRowClick (row) {
      console.log(row)
      this.$refs.tableRef.toggleRowSelection(row)
      this.selectionData = row
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },
    // 盘盈盘亏
    clearBtn () {
      if (this.selectList.length == 0) {
        this.$message.error('请选择一条数据进行操作')
      } else if (this.selectList.length > 1) {
        DonMessage.error('请选择一条数据进行操作')
      } else if (this.selectList[0].number != '0') {
        DonMessage.error('您所选的数据存在件数不为0')
      } else {
        this.$confirm('清零后数据不可恢复，确定清零吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          JfclearStockWarehouse({
            stockWarehouseId: this.selectList[0].stockWarehouseId // 主键id
          }).then((res) => {
            this.$message.success('清零成功')
            this.JfgetStockWarehouseListZYs()
          }).catch((err) => {
            this.$message.error(err.message)
          })
        }).catch(() => {
        })
      }
    },
    // 导出
    exportClick () {
      exportExcel(
        this.global.wmsStockName + '/stockThreadExp/exportStockWarehouseListZy',
        this.searchFrom,
        '仓位库存信息表'
      )
    },
    daoru () {
      this.daoruMark = true
      this.file = []
    },
    closeDialogFile () {
      this.$refs.file.value = ''
    },
    getFile: function (event) {
      this.file = event.target.files[0]
    },
    // 导入-确定
    daoruQueding (event) {
      function extname (filename) {
        if (!filename || typeof filename != 'string') {
          return false
        }
        let a = filename.split('').reverse().join('')
        let b = a.substring(0, a.search(/\./)).split('').reverse().join('')
        return b
      }
      let name = extname(this.file.name)
      if (name == false) {
        this.$alert('文件为空,请选择文件进行导入', '系统提示')
      } else if (name != 'xlsx' && name != 'csv' && name != 'xls') {
        // xls,.csv
        this.$alert('请选择正确的文件格式', '系统提示')
      } else {
        let formData = new FormData()
        // formData=[]
        formData.append('file', this.file)
        // formData.append("planId", this.id);
        this.isDisable1 = true
        JfimportStockWarehouse(formData)
          .then((res) => {
            console.log(res)
            // -1 提示错误信息， 0 成功， 1显示导出异常
            this.daoruMark = false
            this.isDisable1 = false
            this.$message({
              message: res,
              type: 'success'
            })
            this.JfgetStockWarehouseListZYs()
          })
          .catch((err) => {
            // console.log(err)
            if (err.code == -1) {
              this.$message({
                message: err.data == null ? err.message : err.data,
                type: 'error'
              })
              // } else if (err.code == 1) {
              //   this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
              //     confirmButtonText: '确定',
              //     cancelButtonText: '取消',
              //     type: 'warning'
              //   })
              //     .then(() => {
              //       const loading = this.$loading({
              //         lock: true,
              //         text: '正在导出异常信息...'
              //       })
              //       let form = {}
              //       exportExcel(
              //         this.global.wmsStockName + '/packag/exportPackagRecordExc',
              //         form,
              //         '打包记录异常表'
              //       )
              //       setTimeout(() => {
              //         this.$message({
              //           type: 'success',
              //           message: '异常信息导出成功!'
              //         })
              //         loading.close()
              //         this.getPackagRecordListS()

              //         this.daoruMark = false
              //       }, 3000)
              //     })
              //     .catch(() => {
              //       this.$message({
              //         type: 'info',
              //         message: '已取消导出'
              //       })
              //     })
            }

            this.isDisable1 = false
          })
      }
    },
    // 字典--库位
    zidianKuweiS () {
      zidianKuwei({
      })
        .then((res) => {
          this.CangweiOptions = res
          this.CWData = res
        })
        .catch((err) => {
          // console.log(err);
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/template/wms/%E4%BB%93%E4%BD%8D%E5%BA%93%E5%AD%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'// 后更改页面地址
    }
  }
}
</script>
<style scoped lang='less'>
.el-table {
  overflow: visible !important;
}

// .searchBox {
//   margin-left: 10px;
// }
.inpBox {
  margin: 5px 0 0 -30px;
}

/deep/.inpBox .el-input__inner {
  width: 170px;
}

.searchBtnBox {
  margin-top: 10px;
}

.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 40px;
}

.tongJi {
  display: flex;
  margin-left: 10px;
}

.tongJi_item {
  margin-right: 20px;
}

.tongJi_item span {
  color: red;
}

.addstyle {
  margin-left: 94%;
}

.addMarkBox {
  .addMarkBox-title {
    width: 150px;
    font-size: 18px;
    font-weight: 700;
    margin: 0 auto;
  }

  .addMarkBox-content {
    width: 45%;
    margin: 30px auto;

    div {
      padding-bottom: 5px;
      font-weight: 700;

      .ipt {
        width: 150px;
      }
    }
  }
}

.imgDialog {
  width: 100%;
  // height:60vh;
  // overflow-x: scroll;
  // overflow-y: scroll;
  text-align: center;

  img {
    height: calc(100vh - 250px);
    // background-size: 100% 100%;
  }
}

//查看凭证弹窗 -放大
.oneTwo {
  z-index: 11111 !important;
}

.img_box {

  // width: 100%;
  // display: flex;
  // flex-direction: row;
  // align-items: flex-start;
  // flex-wrap: wrap;
  div {
    widows: 150px;
    height: 160px;
    margin-right: 5px;
    // border: 1px dashed #ccc;
    // border-radius: 10px;
    padding: 2px;

    img {
      width: 150px;
      height: 150px;
      margin-left: 50px;
    }
  }
}

.numbers {
  margin-left: 10px;
  margin-right: 10px;
  color: red;
}

.box1 {
  overflow: hidden;
}

.leftbox {
  width: 250px;
  float: left;
  border-right: 1px solid black;
  height: calc(100vh - 250px);
  overflow-y: auto;
  // height:150px;
  // background-color:red;
  // .imgbox{
  //   border-bottom: 1px solid #ccc;
  // }

}

.rightbox {
  margin-left: 50px;
  width: 850px;
  float: left;

  // height:150px;
  // background-color:yellow;
  .pdfbox {
    height: calc(100vh - 250px);
  }
}

/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}

 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
